import { render, staticRenderFns } from "./submit_proposal.vue?vue&type=template&id=7c92f5a3&"
import script from "./submit_proposal.vue?vue&type=script&lang=js&"
export * from "./submit_proposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports